import { render } from "./PicnicView.vue?vue&type=template&id=1c0cefa4&scoped=true"
import script from "./PicnicView.vue?vue&type=script&lant=js&lang=js"
export * from "./PicnicView.vue?vue&type=script&lant=js&lang=js"

import "./PicnicView.vue?vue&type=style&index=0&id=1c0cefa4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c0cefa4"]])

export default __exports__